module.exports = __webpack_public_path__ + "img/join-us-en.3e95515.png";